var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"font-bold rounded-lg border transition-all",class:[_vm.buttonSize, _vm.buttonType, _vm.additionalClass, { disabled: _vm.disabled }],attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }